import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import ReceptaclesInPredesNotInCarditReport
  from '../../components/ReceptaclesInPredesNotInCarditReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/ReceptaclesInPredesNotInCarditDetailsSelectors';
import { ReceptaclesInPredesNotInCarditReportMode } from '../../components/ReceptaclesInPredesNotInCarditReportMode';

export class ReceptaclesInPredesNotInCarditDetailsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportMode: ReceptaclesInPredesNotInCarditReportMode.included,
      showTrafficButton: true,
    };
  }

  changeTrafficMode = () => {
    switch (this.state.reportMode) {
      case ReceptaclesInPredesNotInCarditReportMode.included:
        return this.setState({ reportMode: ReceptaclesInPredesNotInCarditReportMode.excluded });
      case ReceptaclesInPredesNotInCarditReportMode.excluded:
        return this.setState({ reportMode: ReceptaclesInPredesNotInCarditReportMode.included });
      default:
        return (<div id="report-mode-error">Report mode &quot;{this.state.reportMode}&quot; is not implemented</div>);
    }
  };

  renderIncluded() {
    return (
      <ReceptaclesInPredesNotInCarditReport
        reportId={ReportDefinitions.RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_DETAILS.id}
        columns={this.props.columns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data.filter(d => d.isTrafficInternal !== true)}
        showTrafficButton={this.state.showTrafficButton}
        reportMode={ReceptaclesInPredesNotInCarditReportMode.included}
        changeTrafficMode={this.changeTrafficMode}
      />
    );
  }

  renderExcluded() {
    return (
      <ReceptaclesInPredesNotInCarditReport
        reportId={ReportDefinitions.RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_DETAILS.id}
        columns={this.props.columns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        showTrafficButton={this.state.showTrafficButton}
        reportMode={ReceptaclesInPredesNotInCarditReportMode.excluded}
        changeTrafficMode={this.changeTrafficMode}
      />
    );
  }

  render() {
    switch (this.state.reportMode) {
      case ReceptaclesInPredesNotInCarditReportMode.included:
        return this.renderIncluded();
      case ReceptaclesInPredesNotInCarditReportMode.excluded:
        return this.renderExcluded();
      default:
        return (<div id="report-mode-error">Report mode &quot;{this.state.reportMode}&quot; is not implemented</div>);
    }
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

ReceptaclesInPredesNotInCarditDetailsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(ReceptaclesInPredesNotInCarditDetailsContainer);
